var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoOptimotion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11538_4918)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11538_4918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0.833252C15.0585 0.833252 19.1668 4.94159 19.1668 9.99992C19.1668 15.0583 15.0585 19.1666 10.0002 19.1666C4.94183 19.1666 0.833497 15.0583 0.833496 9.99992C0.833496 4.94159 4.94183 0.833252 10.0002 0.833252ZM10.0002 17.4999C14.1335 17.4999 17.5002 14.1333 17.5002 9.99992C17.5002 5.86658 14.1335 2.49992 10.0002 2.49992C5.86683 2.49992 2.50016 5.86659 2.50016 9.99992C2.50016 14.1333 5.86683 17.4999 10.0002 17.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99183 4.99992C10.4502 4.99992 10.8252 5.37492 10.8252 5.83325C10.8252 6.29159 10.4585 6.66659 10.0002 6.66659H9.99183C9.53349 6.66659 9.15849 6.29159 9.15849 5.83325C9.15849 5.37492 9.53349 4.99992 9.99183 4.99992ZM10.0002 8.33325C10.4585 8.33325 10.8335 8.70825 10.8335 9.16659V14.1666C10.8335 14.6249 10.4585 14.9999 10.0002 14.9999C9.54183 14.9999 9.16683 14.6249 9.16683 14.1666V9.16659C9.16683 8.70825 9.54183 8.33325 10.0002 8.33325Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11538_4918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11538_4918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoOptimotion);
export default __webpack_public_path__ + "static/media/icon-info-optimotion.4a4c1d07921f0d878cba2ca5362c0bd4.svg";
export { ForwardRef as ReactComponent };